import React, { useEffect, useState } from "react";
import { Container, Nav, Navbar } from "react-bootstrap";
import { NavLink } from "react-router-dom";
import { HashLink } from "react-router-hash-link";
import "./Navigation.css";

const Navigation = () => {
  const [scroll, setScroll] = useState(false);

  useEffect(() => {
    window.addEventListener("scroll", () => {
      setScroll(window.scrollY > 250);
    });
  }, []);
  return (
    <>
      <Navbar
        collapseOnSelect
        expand="lg"
        variant="dark"
        className={
          scroll
            ? "opacity-100 sticky-top bg-dark"
            : "opacity-100 sticky-top bg-dark"
        }
      >
        <Container>
          <Navbar.Brand href="#home"></Navbar.Brand>
          <Navbar.Toggle aria-controls="responsive-navbar-nav" />
          <Navbar.Collapse
            id="responsive-navbar-nav"
            className="justify-content-end nav-custom"
          >
            <ul className="navbar-nav ms-auto mb-2 mb-lg-0">
              <li className=" u-line px-3 ">
                <Nav.Link className="nav-hover-line" as={HashLink} to="/#home">
                  Home
                </Nav.Link>
              </li>
              <li className=" u-line px-3 ">
                <Nav.Link className="nav-hover-line" as={HashLink} to="/#about">
                  About
                </Nav.Link>
              </li>
              <li className="u-line px-3 ">
                <Nav.Link
                  className="nav-hover-line"
                  as={HashLink}
                  to="/#projects"
                >
                  Projects
                </Nav.Link>
              </li>
              <li className="u-line px-3 ">
                <Nav.Link as={HashLink} to="/#contact">
                  Contact
                </Nav.Link>
              </li>
              <li className="u-line px-3 ">
                <Nav.Link as={NavLink} to="/blogs">
                  Blogs
                </Nav.Link>
              </li>
              <li className="u-line px-3 ">
                <Nav.Link as={NavLink} to="/projectDetails">
                  All-Projects
                </Nav.Link>
              </li>
            </ul>
          </Navbar.Collapse>
        </Container>
      </Navbar>
    </>
  );
};

export default Navigation;
